import store from '@/store'
import { parseNullableId } from '@/lib/helpers/numeric'

// What the phone's two send queues share (P7: the MOVE PRO launches, the Polar
// captures), sent while the network allows it.

// The account signed in on this phone, stamped on what the queues keep.
export const signedInUserId = () => parseNullableId(store.state.auth?.user?.id) ?? null

// Each account sends only what it made: a logout keeps the phone's queues, and
// on a phone a stable shares, a rider's launches and heart rate must never leave
// under the next account. What a former version kept names no account: the
// first one signed in sends it.
export const belongsToSignedInUser = (userId) => {
    const signedIn = signedInUserId()
    const owner = parseNullableId(userId) ?? null
    return signedIn !== null && (owner === null || owner === signedIn)
}

// Runs `pass` one at a time. A call made during a pass asks for one more pass
// after it, so a change made meanwhile is not left behind. A failed pass only
// waits for the next call.
export const onePassAtATime = (pass) => {
    let running = null
    let again = false

    const run = async () => {
        try {
            do {
                again = false
                await pass()
            } while (again)
        } catch (error) {
            console.warn('[Send] Pass failed', error)
        } finally {
            running = null
        }
    }

    return () => {
        if (running) {
            again = true
            return running
        }
        running = run()
        return running
    }
}

// A phone timestamp (ms) as the API takes a date, null when there is none.
export const toIsoDate = (timestamp) => {
    const ms = Number(timestamp)
    return Number.isFinite(ms) && ms > 0 ? new Date(ms).toISOString() : null
}
